import { BookingTrackingRS } from './affiliate.interfaces';

export const fakeAffiliate: BookingTrackingRS = {
    success: true,
    data: {
        items: [],
        booking: {},
    },
};
